import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsersEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.22146 16.2391L4.06507 16.6703L4.49635 14.5139C4.57379 14.1267 4.76409 13.7712 5.04329 13.492L12.2718 6.2634L13.2148 5.32039C13.6053 4.92986 14.2385 4.92986 14.629 5.32039L15.4149 6.10633C15.8054 6.49685 15.8054 7.13002 15.4149 7.52054L14.4719 8.46355L7.24345 15.6921C6.96425 15.9713 6.60865 16.1616 6.22146 16.2391Z",
		fill: "#FF3131"
	})
});
export default SvgUsersEdit;
